import { Mountain, Brain, Sparkles, Target } from "lucide-react";

export function LoadingState() {
  return (
    <div className="min-h-screen flex items-center justify-center gradient-bg-futuristic overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-gradient-to-r from-teal-500 to-green-500 blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 rounded-full bg-gradient-to-r from-[var(--apple-green)] to-[var(--apple-orange)] blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      
      <div className="text-center relative z-10">
        <div className="mb-8">
          {/* Main loading icon */}
          <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-r from-[var(--apple-blue)] to-[var(--apple-purple)] rounded-3xl flex items-center justify-center shadow-2xl floating-element pulsing-glow">
            <Mountain className="w-12 h-12 text-white" />
          </div>
          
          {/* Processing steps */}
          <div className="flex justify-center space-x-6 mb-6">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mb-2 shadow-lg animate-slow-pulse pulsing-glow-teal">
                <Brain className="w-6 h-6 text-white" />
              </div>
              <span className="text-xs text-gray-400">Analyzing</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-gradient-to-r from-[var(--apple-green)] to-[var(--apple-green-light)] rounded-2xl flex items-center justify-center mb-2 shadow-lg animate-slow-pulse pulsing-glow-green" style={{ animationDelay: '1s' }}>
                <Target className="w-6 h-6 text-white" />
              </div>
              <span className="text-xs text-gray-400">Planning</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-gradient-to-r from-[var(--apple-orange)] to-[var(--apple-orange-light)] rounded-2xl flex items-center justify-center mb-2 shadow-lg animate-slow-pulse pulsing-glow-orange" style={{ animationDelay: '2s' }}>
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <span className="text-xs text-gray-400">Optimizing</span>
            </div>
          </div>
          
          <h3 className="text-3xl font-bold mb-2 text-white">Your Plan Is Taking Shape</h3>
          <p className="text-gray-300 mb-4">This Could Take A While, But Greatness Doesn't Do Shortcuts.</p>
          
          {/* Loading dots - moved higher */}
          <div className="flex justify-center space-x-2">
            <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
}
